import Validator from "validatorjs";

export const validateClaimAmount = (
  claimAmount,
  prevClaimAmount,
  faceValue
) => {
  if (!claimAmount) return "Amount is required.";
  const totalClaimAmount = Number(claimAmount) + Number(prevClaimAmount);
  if (totalClaimAmount < 0.01) {
    return "Invalid claim amount.";
  } else if (totalClaimAmount > faceValue) {
    return "Total claim amount cannot be greater than face value.";
  }
};

export const validate = (claimAmount, prevClaimAmount, faceValue) => {
  if (!claimAmount) {
    return undefined;
  }

  const totalClaimAmount = Number(claimAmount) + Number(prevClaimAmount);

  const fields = {
    claimAmount,
    totalClaimAmount
  };

  const rules = {
    claimAmount: ["regex:/^\\d+(,\\d{3})*(\\.\\d*)?$"],
    totalClaimAmount: ["min:0.1", `max:${faceValue}`]
  };

  const errorMessages = {
    "regex.claimAmount": "Claim amount is invalid.",
    "min.totalClaimAmount": "Claim amount must be greater than zero.",
    "max.totalClaimAmount":
      "Total claim amount cannot be greater than face value."
  };

  const validator = new Validator(fields, rules, errorMessages);
  validator.passes();

  const errors = validator.errors.all();

  // NOTE: As Redux form does not handle submission errors and field-level errors consistently,
  // convert data structure from object to array.

  if (errors.claimAmount) {
    return [errors.claimAmount];
  }

  if (errors.totalClaimAmount) {
    return [errors.totalClaimAmount];
  }
};

export const issue = value => {
  if (!value) return "Issue is required.";
};

export const secondaryIssue = (value, props) => {
  if (!value) {
    if (props.issue?.display === "Other") {
      return "Subject is required.";
    } else if (props.issue?.display === "Card missing information") {
      return "Please provide what's missing.";
    } else if (
      props.issue?.display === "Balance discrepancy" ||
      props.issue?.display === "Card number invalid" ||
      props.issue?.display === "Not accepted by merchant"
    ) {
      return "Where did you attempt to use it?";
    }
  }
  if (!value) return "Issue is required.";
};

export const subject = value => {
  if (!value) return "Subject is required.";
};

export const message = (value, props) => {
  if (props.issue?.display === "Did not receive my card") {
    return;
  } else if (
    props.issue?.display === "Other" ||
    props.issue?.display === "Balance discrepancy" ||
    props.issue?.display === "Card number invalid" ||
    props.issue?.display === "Not accepted by merchant"
  ) {
    if (!value) {
      return "Message is required.";
    }
  } else if (props.issue?.display === "Card missing information") {
    if (props.secondaryIssue?.display === "Other") {
      return "Message is required.";
    }
  }
};

export const supportMessage = value => {
  if (!value) return "Message is required.";
};
